import React, { useState } from 'react';
import OrdersListStandalone from '../components/OrdersListStandalone';
import OrdersFilter from '../components/OrdersFilter';
import OrdersSearch from '../components/OrdersSearch';
import OrdersStats from '../components/OrdersStats';
import useFirebaseSync from '../hooks/useFirebaseSync';

const OrdersPageEnhanced = () => {
  const [useFilters, setUseFilters] = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    status: '',
    dateRange: 'all'
  });
  const [searchParams, setSearchParams] = useState({
    term: '',
    field: 'all'
  });

  const { data: orders } = useFirebaseSync('orders', {
    orderByField: 'createdAt',
    orderDirection: 'desc'
  });

  const handleFilterChange = (filters) => {
    setActiveFilters(filters);
  };

  const handleSearch = (search) => {
    setSearchParams(search);
  };

  const toggleFilters = () => {
    setUseFilters(!useFilters);
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Commandes</h1>
        <button
          onClick={toggleFilters}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {useFilters ? 'Masquer les filtres' : 'Afficher les filtres'}
        </button>
      </div>

      {orders && <OrdersStats orders={orders} />}

      <OrdersSearch onSearch={handleSearch} />
      
      {useFilters && <OrdersFilter onFilterChange={handleFilterChange} />}
      
      <OrdersListStandalone 
        filters={activeFilters}
        search={searchParams}
      />
    </div>
  );
};

export default OrdersPageEnhanced;
